module.exports = __webpack_public_path__ + "static/media/information.0fd5ae40.svg";